import {useEffect} from 'react'
import {embeddedPartnerApi, ApiHook} from 'api'
import {useStore} from 'store'

const INTERVAL_TIME = 30000 // milliseconds

const {fetchAccount} = embeddedPartnerApi

export const useCryptoAccountBalance = () => {
	const {selectedCryptoAccount, setSelectedCryptoAccount} = useStore()

	const {request, response} = ApiHook(() => fetchAccount(selectedCryptoAccount?.accountId as any))

	useEffect(() => {
		if (!selectedCryptoAccount?.accountId) return
		request()
		const interval = setInterval(() => {
			request()
		}, INTERVAL_TIME)
		return () => {
			clearInterval(interval)
		}
	}, [selectedCryptoAccount])

	useEffect(() => {
		if (response) setSelectedCryptoAccount(Object.assign(selectedCryptoAccount || {}, response))
	}, [response])
}
